enum modal {
    'title' = 'Modal Title',
    'message' = 'Modal body text goes here.',
}

export default modal;
